export const SET_SELECTED_SERVICES = 'SET_SELECTED_SERVICES';
